import React, { useState } from "react";
import { X } from "lucide-react";

/* Slim dismissible announcement bar fixed at the very top of the site. */
export default function AnnouncementBar() {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 inset-x-0 z-[100] bg-black border-b border-gold/40"
    >
      <div className="relative flex items-center justify-center px-10 py-2">
        <p className="font-display text-[0.62rem] sm:text-[0.72rem] tracking-[0.22em] text-gold-soft text-center">
          🎁 FREE SHIPPING ON ALL STARTER KITS — LAUNCH WEEK ONLY
        </p>
        <button
          onClick={() => setOpen(false)}
          aria-label="Dismiss announcement"
          data-testid="announcement-dismiss"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gold/60 hover:text-gold transition-colors"
        >
          <X size={15} />
        </button>
      </div>
    </div>
  );
}
